import StyleWrap from 'components/Content/StyleWrap/StyleWrap';

export default StyleWrap;
